import { createSelector } from '@reduxjs/toolkit';

const selectOrganization = (state) => {
  return state.organizationStore;
};

export const getOrganizationData = createSelector([selectOrganization], (organizationStore) => {
  return organizationStore?.data || {};
});
